export const PENDO_CLASS_REPORTS_DOWNLOAD_REPORT = 'platform-download-report';

export const PENDO_CLASS_SCHEDULER_COPY_SHARE_LINK = 'collaboration-copy-share-link';

export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_CONTACT_US_LINK =
    'signup-add-social-profile-cantfind-contactus';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_ALL_NETWORK = 'signup-add-social-profile-click';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_FB = 'signup-add-social-profile-click-fb';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_IG = 'signup-add-social-profile-click-ig';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_LI = 'signup-add-social-profile-click-li';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_TK = 'signup-add-social-profile-click-tk';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_YT = 'signup-add-social-profile-click-yt';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_PI = 'signup-add-social-profile-click-pi';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_X = 'signup-add-social-profile-click-x';
export const PENDO_CLASS_SIGNUP_STEP_ADD_SP_TH = 'signup-add-social-profile-click-th';
export const PENDO_CLASS_SIGNUP_CONTACT_US = 'signup-add-social-profile-contactus';
export const PENDO_CLASS_SIGNUP_POPIN_CONFIRM_EMAIL_NEW_CONFIRMATION_LINK =
    'signup-popin-confirm-newlink';

export const PENDO_CLASS_DATA_ACCESS_REFRESH_ACCESS = 'data-access-refresh-access';

export const PENDO_CLASS_SETTINGS_ACCOUNT_SAVE = 'settings-account-save';
export const PENDO_CLASS_SETTINGS_PLATFORM_SAVE = 'settings-platform-save';
export const PENDO_CLASS_SETTINGS_THEMES_LIGHT = 'settings-themes-light';
export const PENDO_CLASS_SETTINGS_THEMES_DARK = 'settings-themes-dark';

export const PENDO_CLASS_DASHBOARD_CUSTOMIZE_REPORT = 'dashboard-customize-report';
export const PENDO_CLASS_DASHBOARD_CUSTOM_SAVE_GENERATE = 'dashboard-custom-report-save-generate';

export const PENDO_CLASS_ALBUM_EXPORT_CONFIRM = 'album-export';

// GROUP
export const PENDO_CLASS_ANALYTICS_GROUP_OVERVIEW_EXPORT = 'analytics-groups-overview-export';

// network insight
export const PENDO_CLASS_NETWORK_INSIGHT = 'pendo-settings-addsp-';
